import {ProgramdayModel} from 'models/program/ProgramdayModel'
import {ProgramModel} from 'models/program/ProgramModel'
import {SequenceModel} from 'models/program/SequenceModel'
import {SpeakerModel} from 'models/program/SpeakerModel'
import {SummitType, WysiwygType} from 'types'
import {Memoize} from 'util/memoize'

export type SequenceSessionData = {
	channel: 'session_sequence'
	url: string
	title: string
	start_time: string
	end_time: string
	short_desc: string
	description: WysiwygType
	speakers: Array<{id: number}>
	summits: Array<SummitType>
}

export class SequenceSessionModel {
	sequence: SequenceModel
	data: SequenceSessionData

	constructor(sequence: SequenceModel, data: SequenceSessionData) {
		this.sequence = sequence
		this.data = data
	}

	@Memoize()
	get day(): ProgramdayModel {
		return this.sequence.day
	}

	@Memoize()
	get program(): ProgramModel {
		return this.sequence.program
	}

	@Memoize()
	get url(): string {
		return this.data.url
	}

	@Memoize()
	get path(): string {
		return this.program.generatePathFromUrl(this.url)
	}

	@Memoize()
	get speakers(): Array<SpeakerModel> {
		return this.data.speakers
			.map(link =>
				this.program.speakers.find(speaker => speaker.id === link.id)
			)
			.filter(speaker => !!speaker)
	}

	@Memoize()
	get title(): string {
		return this.data.title
	}

	@Memoize()
	get room(): string {
		return this.sequence.room
	}

	@Memoize()
	get shortDescription(): string {
		return this.data.short_desc
	}

	@Memoize()
	get description(): WysiwygType {
		return this.data.description
	}

	@Memoize()
	get start_time(): string {
		return this.data.start_time
	}

	@Memoize()
	get end_time(): string {
		return this.data.end_time
	}

	@Memoize()
	get summits(): Array<SummitType> {
		return this.data.summits
	}
}
